import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  PhoneAndroid,
  KeyboardArrowDown,
  Email,
  Call,
} from '@material-ui/icons'
import { Menu, MenuItem, ListItemText } from '@material-ui/core'
import Button from 'components/theme/Button'
import { selectFromNumber } from 'actions/inbox'
import { toggleManagePhonesModal } from 'actions/tasks'

class FromNumberMenu extends Component {
  state = { anchorEl: null }

  // componentWillUnmount() {
  //   this.props.changeTo('')
  // }

  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget })
  }

  handleClose = () => {
    this.setState({ anchorEl: null })
  }

  render() {
    const {
      messageType,
      // conversationSelected,
      // conversation,
      // contactSelected,
      // to,
      selectFromNumber,
      selectedFromNumber,
      fromNumbers,
    } = this.props
    const { anchorEl } = this.state

    // const contact = contactSelected
    //   ? contactSelected
    //   : conversation && conversation.contact
    //   ? conversation.contact
    //   : null

    const typeObj = {
      text: { icon: <PhoneAndroid style={{ marginRight: 5 }} /> },
      email: { icon: <Email style={{ marginRight: 5 }} /> },
      call: { icon: <Call style={{ marginRight: 5 }} /> },
    }

    const userSubtitle = fromNumber => {
			const user = this.props.users?.[fromNumber.vast_user_name]
      return user ? `${user.first_name} ${user?.last_name?.slice?.(0,1)}` : 'Unknown user'
    }

    return (
      <Fragment>
        {selectedFromNumber.phone_number === 'none' ? (
          /* eslint-disable-next-line */
          <a href="#" onClick={() => this.props.toggleManagePhonesModal()}>
            Click here to add a phone number
          </a>
        ) : (
          <Button
            // style={
            //   messageType === 'text'
            //     ? { position: 'absolute', left: 4, top: 7 }
            //     : { margin: '0 5px' }
            // }
            style={{
              margin: '0 0 0 5px',
              textTransform: 'none',
              maxWidth: 200,
              overflow: 'hidden',
            }}
            variant="outlined"
            size="small"
            aria-owns={anchorEl ? 'simple-menu-from-number' : undefined}
            aria-haspopup="true"
            onClick={this.handleClick}
            title={selectedFromNumber.phone_number}
            // disabled={!conversationSelected && !contactSelected}
          >
            {typeObj[messageType].icon}
            {selectedFromNumber.phone_number}
            <KeyboardArrowDown />
          </Button>
        )}
        <Menu
          id="simple-menu-from-number"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={() => this.handleClose()}
        >
          {typeof fromNumbers === 'object' &&
            Object.values(fromNumbers).map(fromNumber => (
              <MenuItem
                key={`fromNumberSelectFieldValue${fromNumber.id}`}
                value={fromNumber}
                onClick={() => {
                  this.handleClose()
                  selectFromNumber(fromNumber)
                }}
              >
                <ListItemText
                  primary={fromNumber.phone_number}
                  secondary={userSubtitle(fromNumber)}
                />
              </MenuItem>
            ))}
        </Menu>
      </Fragment>
    )
  }
}

export default connect(
  state => ({
    messageType: state.inbox.to.current.type,
    // conversationSelected: state.inbox.conversationSelected,
    // to: state.inbox.to.current.value,
    // conversation: state.inbox.conversation,
    // contactSelected: state.inbox.contactSelected,
    selectedFromNumber: state.inbox.fromNumberSelected,
    fromNumbers: state.data?.phonenumbers,
    users: state.data['account/user'],
  }),
  dispatch =>
    bindActionCreators({ selectFromNumber, toggleManagePhonesModal }, dispatch),
)(FromNumberMenu)
